module.exports = __webpack_public_path__ + "static/media/landing-image-tablet@2x.f9ca46e7.png";